import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "folder-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "overlay-folder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_overlay_panel = _resolveComponent("app-overlay-panel")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      ref: "targetRef",
      class: "icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCardOverlayPanel && _ctx.toggleCardOverlayPanel(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        size: "sm",
        icon: ['fas', 'ellipsis-v']
      })
    ], 512),
    _createElementVNode("div", {
      class: _normalizeClass(["folder-card", { cardSelected: _ctx.isSelected }]),
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selected && _ctx.selected(...args)))
    }, [
      _createElementVNode("img", {
        loading: "lazy",
        class: _normalizeClass({ 'fade-in': _ctx.onLoad }),
        src: require('@/assets/rainbow-folder.png'),
        alt: "Rainbow Folder",
        onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onLoad && _ctx.onLoad(...args)))
      }, null, 42, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.folder.name), 1)
      ]),
      (_ctx.targetRef)
        ? (_openBlock(), _createBlock(_component_app_overlay_panel, {
            key: 0,
            visible: _ctx.visible,
            "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
            width: 150,
            target: _ctx.targetRef,
            position: {
          x: 'right',
          y: 'center',
        }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "overlay-folder-item",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openCreateFolderModal && _ctx.openCreateFolderModal(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "sm",
                    icon: ['fas', 'fa-pencil']
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t('edit')), 1)
                ]),
                _createElementVNode("div", {
                  class: "overlay-folder-item",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteFolder && _ctx.deleteFolder(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "sm",
                    icon: ['fas', 'fa-trash']
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t('delete')), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible", "target"]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}